import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';

// Scope Sentry events to the current Clerk user. Mirrors the
// ClerkAuthBridge pattern in main.jsx but for Sentry user context
// rather than the API token getter. Clears the user when signed out.
export default function SentryUserBridge({ children }) {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;
    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [isLoaded, user]);

  return children;
}
